import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ccb37b9")

_pushScopeId("data-v-5ccb37b9")
const _hoisted_1 = { class: "license-title" }
const _hoisted_2 = { class: "expires-license" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Expires: ")
const _hoisted_5 = { class: "license-line license-token" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Download")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Copy token")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "documentation" }, [
  /*#__PURE__*/_createTextVNode(" How to use? Read our "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://proip.info/docs",
    target: "_blank"
  }, "documentation"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "license-line license-expired" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "setting-license-block" }, [
  /*#__PURE__*/_createVNode("h5", { class: "mb-10" }, "Settings")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_icon = _resolveComponent("a-icon")
  const _component_CalendarOutlined = _resolveComponent("CalendarOutlined")
  const _component_a_row = _resolveComponent("a-row")
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock(_component_a_card, { class: "card-license gx-card-widget" }, {
    default: _withId(() => [
      _createVNode(_component_a_row, { class: "license-head" }, {
        default: _withId(() => [
          _createVNode(_component_a_col, { md: 12 }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("h4", null, _toDisplayString(_ctx.license.database.name) + " DB", 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { md: 12 }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_a_icon, { type: "calendar" }),
                _hoisted_3,
                _createVNode(_component_CalendarOutlined),
                _hoisted_4,
                _createVNode("strong", null, _toDisplayString(_ctx.dayjs(_ctx.license.expiredAt).format("LLL")), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withId(() => [
          _createVNode(_component_a_col, { md: 12 }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  size: "default",
                  onClick: _ctx.downloadBase,
                  class: "mr-15 mb-10"
                }, {
                  icon: _withId(() => [
                    _createVNode(_component_DownloadOutlined)
                  ]),
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode("span", {
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.openNotificationCopy('Token'))),
                  class: "copy-token mr-15 mb-10"
                }, [
                  _createVNode(_component_CopyOutlined),
                  _hoisted_7
                ])
              ]),
              _hoisted_8,
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { md: 12 }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})